export default function () {
  return {
    user: {
      user: {}
    },
    loggedIn: false,
  }
}
